var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"bers-product-type bers-p-fieldset"},[_c('intro',{attrs:{"headline":_vm.properties.title,"introText":_vm.properties.text}}),_c('toggle',{attrs:{"items":_vm.properties.values}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }